// --------------------------------------------------------
// src/views/credits.view.js
//
// Manage the view/template of the credit page
//
// --------------------------------------------------------
"use strict";

const CREDITS_TEMPLATE = `
<div class="col-lg-12 full-book p40">
    <h2 class="creditsAuthors"><%= app.localeManager.get("credits.authors") %></h2>
    <div id="credits-alphafilter-component"></div>
    <div id="authors-collection-component"></div>

	<div class="clearfix"></div>

	<h2 class="mtop-15"><%= app.localeManager.get("credits.publishers") %></h2>
    <ul class="publishers-list p0">
        <% for (var j = 0; j < this.publishers.length; j++) { %>
            <li><%= this.publishers[j] %></li>
        <% } %>
	</ul>
    <div class="clearfix"></div> 
`;

// The view for a single book model
const CreditsPage = Backbone.View.extend({

    authors: {},

    displayedAuthors: {},
    
    publishers: [],

	// The DOM element that will be created
	tagName: "section",

	// The classname for the tagName
	className: "container ptop-40",

    components: {
        alphafilter: {},
        authorCollection: {}
    },

    events: {
        "letter #credits-alphafilter-component": "handleAlphaFilterEvent",
    },

    // Convert the template to html
	template: _.template( CREDITS_TEMPLATE ),

	// Called when this object is created
	initialize: function(options) {
        // Overriding the default "constructor"
        // We need to pass additional parameters (authors and publishers) to the "constructor"
        this.options = options || {};
        // The main objects
        this.authors = this.options.authors;
        this.publishers = this.options.publishers;
        this.displayedAuthors = this.authors;
        // The subcomponents
        this.components.alphafilter = new AlphaFilterComponent({ collection: this.authors.clone(), keyMapping: "name" });
        this.components.authorCollection = new AuthorCollectionComponent({ collection: this.displayedAuthors });
    },

    afterRender: function() {
        // do not remove this function
    },

	// Render the template
	render: function() {
		this.$el.html(this.template(this));
        this.$el.find("#credits-alphafilter-component").html(this.components.alphafilter.render().el);
        this.$el.find("#authors-collection-component").html(this.components.authorCollection.render().el);

		return this;
    },

    reRender: function() {
        this.$el.find("#authors-collection-component").html(this.components.authorCollection.render().el);
    },

    handleAlphaFilterEvent: function(e) {
        this.update(e.originalEvent.detail.collection());
    },

    update: function(coll) {
        this.displayedAuthors.set(coll);
    },
});
